<template>
    <v-dialog
    v-model="localValue"
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Nova grupa
      </v-card-title>

      <v-card-text>
        <AppSpinner v-if="!loaded" />
        <GroupForm
          ref="groupForm"
          :modalView="true"
          :taxLevels="taxLevels"
          :taxTypes="taxTypes"
          @save="saveAndClose"
          @cancel="cancel"
          v-else
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
// import AppSpinner from './AppSpinner'
import GroupForm from './GroupForm'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    GroupForm
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      loaded: false,
      localValue: this.value
    }
  },
  computed: {
    taxLevels () {
      return objectToArray(this.$store.state.taxLevels.items)
    },
    taxTypes () {
      return objectToArray(this.$store.state.taxTypes.items)
    }
  },
  methods: {
    ...mapActions('taxLevels', { loadTaxLevels: 'loadItems' }),
    ...mapActions('taxTypes', { loadTaxTypes: 'loadItems' }),
    saveAndClose (form) {
      this.$emit('input', false)
      this.$emit('confirmed', form)
    },
    cancel () {
      this.clearForm()
      this.$emit('input', false)
    },
    clearForm () {
      this.$refs.groupForm.clearForm()
    }
  },
  created () {
    Promise.all([
      this.loadTaxLevels(),
      this.loadTaxTypes()
    ])
      .then(items => { this.loaded = true })
  },
  watch: {
    value (newVal) {
      this.localValue = newVal
    },
    localValue (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
